import { TbHealthRecognition } from "react-icons/tb";

import ThinCategoryCard from "../../../../../components/cards/thin-card";
import textUtils from "../../../../../utils/textUtils";
import { BasicCardWrapper, GestaoConveniadosContainer } from "../../../cardDescontos/style";
import { partnerContentSaude } from "./content";

export const Partners = () => {
  const { partner_summary_saude } = partnerContentSaude;

  return (
    <div>
      <GestaoConveniadosContainer>
        <div>
          <span style={{ display: "flex", gap: "0.5rem" }}>
            <h3>{textUtils.handleTextHigliht(partner_summary_saude.title)}</h3>
            <TbHealthRecognition
              size={28}
              color="#d03119"
            ></TbHealthRecognition>
          </span>{" "}
            
          <BasicCardWrapper>
            {partner_summary_saude.categories.map((category, index) => {
              return (
                <ThinCategoryCard
                  nome={category.name}
                  imagem={category.img}
                  id={index}
                  key={index}
                  routePrefix="cartao-saude/categoria"
                />
              );
            })}
          </BasicCardWrapper>
        </div>
      </GestaoConveniadosContainer>
    </div>
  );
};
